import { useRef } from "react";

import { CSSTransition } from "react-transition-group";

const Resizing = ({resizingOn, pageCurrent}) => {
  const partResizingRef = useRef(null);
  let rzTimeout = 2500;
  let rzDelay = '2s';

  if(pageCurrent === 'coming' || pageCurrent === 'error') {
    rzTimeout = 1500;
    rzDelay = '1s';
  }

  return (
    <CSSTransition nodeRef={partResizingRef} in={resizingOn} timeout={rzTimeout} classNames='resizing' mountOnEnter unmountOnExit>

      <div className="part resizing" ref={partResizingRef} style={{'--rz-delay': rzDelay}}>  
        <section className="sector sector-h-full">
          <div className="container container-w-full container-w-no-gutter-out">
            <div className="container-in" >

              <div className="contents-wrapper">
                <div className="rz-letters">
                  <span>R</span>
                  <span>E</span>
                  <span>S</span>
                  <span>I</span>
                  <span>Z</span>
                  <span>I</span>
                  <span>N</span>
                  <span>G</span>
                </div>
              </div>

            </div>
          </div>
        </section>  
      </div>

    </CSSTransition>
  )
}

export default Resizing;

